
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/siteCreation/horizontalLoader.scss.css.virtualfile';
        module.exports = {"siteCreationHorizontalLoader":"_siteCreationHorizontalLoader_s7gr5_1"};